import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

// Axios Request
import { fetchSinglePost } from '../requests/singlepost_request';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Loader from '../components/Loader';
import RenderSingleFriendly from '../components/Pages/RenderSingleFriendly';
import Share from '../components/Pages/Share';

import _ from 'lodash';

class BeFriendly extends Component {
    componentDidMount() {
        document.title = `Be Friendly - Friends for Brands`;
        window.scrollTo(0, 0);
    }

    componentWillMount() {
        this.getPosts(this.props, true);
    }

    componentWillReceiveProps(nextProps) {
        this.getPosts(nextProps);
    }

    curPost() {
        if (this.props.posts[0]) {
            const currentIndex = _.findIndex(this.props.work.posts, [
                'slug',
                this.props.match.params.slug,
            ]);
            return currentIndex;
        } else {
            return 0;
        }
    }

    getPosts(props, willMount = false) {
        var slug = this.props.match.path;
        slug = slug.substring(1);
        if (willMount) {
            this.props.fetchSinglePost('pages', slug);
        }
    }

    render() {
        return (
            <div className="single be-friendly">
                <Header />
                {this.props.posts.fetched ? (
                    <div className="fadeIn">
                        <img
                            alt="Be Friendly"
                            src={
                                this.props.posts.posts[0].better_featured_image
                                    .source_url
                            }
                        />
                    </div>
                ) : (
                    ''
                )}
                <main>
                    <div id="main-container">
                        <div className="content-container">
                            <Loader loaded={this.props.posts.fetched} />
                            {!!this.props.posts.fetched ? (
                                <div className="fadeIn">
                                    <h1>{this.props.title}</h1>
                                    <div className="share-withcover">
                                        <Share
                                            type={
                                                this.props.posts.posts[0].type
                                            }
                                            title={
                                                this.props.posts.posts[0].title
                                                    .rendered
                                            }
                                        />
                                    </div>
                                    <RenderSingleFriendly
                                        posts={this.props.posts}
                                    />
                                </div>
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <Footer />
                </main>
            </div>
        );
    }
}

function mapStateToProps({ posts }) {
    return { posts };
}

export default withRouter(
    connect(mapStateToProps, { fetchSinglePost })(BeFriendly)
);



// WEBPACK FOOTER //
// ./src/containers/BeFriendly.jsx